import { FC, SVGAttributes } from "react";

const ChevronLeftSmall: FC<SVGAttributes<SVGSVGElement>> = (rest) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="3"
    height="5"
    viewBox="0 0 3 5"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <path d="M2.5 4.5L0.5 2.5L2.5 0.5" />
  </svg>
);

export { ChevronLeftSmall };
